<template>
  <div class="scene-list-item">
    <a :href="`/items?scene_id=${sceneId}`" class="scene-list-item__link">
      <img :alt="sceneName" :src="imageUrl" class="scene-list-item__image" />
      <div class="scene-list-item__overlay">
        <p class="scene-list-item__name">{{ sceneName }}</p>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    sceneId: {
      type: Number,
      required: true
    },
    sceneName: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.scene-list-item {
  width: 198px;
  min-width: 198px;
  height: 111px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &__link {
    @extend %hover-common;
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__image {
    position: absolute;
    width: 100%;
    max-height: 100%;
  }

  &__overlay {
    width: 100%;
    height: 100%;
    background-color: $light_black_cover;
    position: absolute;
    font-weight: bold;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__name {
    position: absolute;
    color: $white;
    font-size: 1.6rem;
    line-height: 1.6;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
  }
}
</style>
